import axios from "axios"

const Axios = axios.create({
  // axios实例配置
  timeout: 15000,
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
})

export const Get = (url, config={}) => {
  return new Promise((resolve) => {
    Axios
      .get(url, config)
      .then((res) => {
        resolve([null, res.data])
      })
      .catch((err) => {
        resolve([err.response.data, undefined])
      })
  })
}

export const Post = (url, data, config={}) => {
  return new Promise((resolve) => {
    Axios
      .post(url, data, config)
      .then((res) => {
        resolve([null, res.data, res.headers])
      })
      .catch((err) => {
        resolve([err.response.data, undefined])
      })
  })
}
